import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import { Account, AccountBalance, Program } from '@monorepo/types';
import { ObjectiveData } from '../../types';
import {
  getMainTextStyle,
  getSecondaryTextStyle,
  getValueProps,
} from '../../utils/styles';

/**
 * Base hook for common objective component logic
 */
export const useObjectiveBase = () => {
  const { t } = useTranslation('dashboardHeader');
  const theme = useTheme();
  const valueProps = getValueProps(theme);

  return {
    t,
    theme,
    valueProps,
    getMainTextStyle,
    getSecondaryTextStyle,
  };
};

/**
 * Common interface for objective component props
 */
export interface BaseObjectiveProps {
  account?: Account;
  accountBalance?: AccountBalance;
  program?: Program | null;
}

/**
 * Type for objective component functions
 */
export type ObjectiveComponent = (props: BaseObjectiveProps) => ObjectiveData;
